// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"ab631cf2","254":"844d0485","642":"06d216d9"}[chunkId] + ".chunk.js";
};